import { LinkData } from '@propertypal/shared/src/types/siteMap';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Chevron from '../icons/Chevron';
import PageWrapper from '../layout/PageWrapper';
import { Heading, SubHeading, Text } from '../typography';
import { BackLink, List, ListItem, Section } from './SiteMapGlobal.style';

interface SiteMapData {
  data: LinkData[];
  letter: string;
}

const SiteMapAgent: FunctionComponent<SiteMapData> = (props) => {
  const theme = useTheme();

  return (
    <>
      <Section>
        <PageWrapper>
          <BackLink href="/site-map" prefetch={false}>
            <Text color={theme.primary} fontSize={16}>
              <Chevron size={12} direction="left" /> Back to Site Map
            </Text>
          </BackLink>

          <Heading fontSize={32} fontWeight="300" style={{ marginTop: 30, overflow: 'hidden' }}>
            {platform.domain.toUpperCase()} SITE MAP
          </Heading>
        </PageWrapper>
      </Section>
      <Section noBg>
        <PageWrapper>
          <SubHeading fontSize={22} color={theme.primary} fontWeight="300" mt={30} mb={30}>
            ESTATE AGENTS BEGINNING WITH {props.letter}
          </SubHeading>
          <List>
            {props.data.map((agent) => {
              return (
                <ListItem key={agent.label}>
                  <Link href={agent.url} prefetch={false}>
                    <Text fontSize={16}>{agent.label}</Text>
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </PageWrapper>
      </Section>
    </>
  );
};

export default SiteMapAgent;
